import React, { useEffect, useRef, useState } from 'react';
import IconActionButton from '@/components/molecules/IconActionButton/IconActionButton';
import Icon, { IconColor } from '@/components/atoms/UI/Icon/Icon';
import { BreakOverlay, HalfLeft, HalfRight, IconBeat } from './styles';

interface Props {
    label: string;
    iconColor?: IconColor;
    disabled?: boolean;
    onClick?: () => void;
    pressed?: boolean;
    // Анимации играем по ИНКРЕМЕНТУ нонса (явное действие), а НЕ по смене
    // pressed — иначе гидрация/оптимистичный откат/синк стора дают ложный
    // «раскол сердца» на загрузке уже-избранного теста.
    beatNonce?: number;
    breakNonce?: number;
}

const prefersReducedMotion = (): boolean =>
    typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const FavoriteHeartButton: React.FC<Props> = ({
    label,
    iconColor = 'white',
    disabled,
    onClick,
    pressed,
    beatNonce,
    breakNonce,
}) => {
    const [beat, setBeat] = useState(false);
    const [breaking, setBreaking] = useState(false);
    const prevBeat = useRef(beatNonce);
    const prevBreak = useRef(breakNonce);

    useEffect(() => {
        if (beatNonce === prevBeat.current) return;
        prevBeat.current = beatNonce;
        if (!prefersReducedMotion()) setBeat(true);
    }, [beatNonce]);

    useEffect(() => {
        if (breakNonce === prevBreak.current) return;
        prevBreak.current = breakNonce;
        if (!prefersReducedMotion()) setBreaking(true);
    }, [breakNonce]);

    return (
        <IconActionButton
            iconName="Heart"
            label={label}
            iconColor={iconColor}
            pressed={pressed}
            disabled={disabled}
            onClick={onClick}
        >
            <IconBeat $beat={beat} onAnimationEnd={() => setBeat(false)}>
                <Icon name="Heart" color={iconColor} small />
            </IconBeat>

            {breaking && (
                <BreakOverlay aria-hidden="true" data-testid="break-overlay">
                    <HalfLeft onAnimationEnd={() => setBreaking(false)}>
                        <Icon name="Heart" color="error" small />
                    </HalfLeft>
                    <HalfRight>
                        <Icon name="Heart" color="error" small />
                    </HalfRight>
                </BreakOverlay>
            )}
        </IconActionButton>
    );
};

export default FavoriteHeartButton;
